import classNames from 'classnames';
import React from 'react';
import { PaddingContainer } from '@components';
import * as styles from './QuoteWithTestersPhoto.module.scss';
import { graphql, useStaticQuery } from 'gatsby';
import { keysToCamel } from '@utils/snakeCaseParser';

export const QuoteWithTestersPhoto: React.FC = () => {
	const { directus } = useStaticQuery(graphql`
		query TestersImage {
			directus {
				about_us {
					qa {
						imageFile {
							publicURL
						}
						id
					}
				}
			}
		}
	`);

	const testersImage = keysToCamel(directus);

	return (
		<PaddingContainer className={'gray-bg py-0'}>
			<div className={styles.quoteWithTestersContainer}>
				<div className="row no-gutters">
					<div
						className={classNames(
							styles.quote,
							'col-12 col-xl-6 font-size-small-title orange-font d-flex align-items-center pr-5'
						)}
					>
						We are treating this process as an integral part of software
						development. EMBIQ experts can assure the best knowledge and actions
						for your product.
					</div>
					<div className="col-12 col-xl-6 d-flex">
						<img
							src={testersImage.aboutUs.qa.imageFile.publicURL}
							className={styles.testersImage}
						/>
					</div>
				</div>
			</div>
		</PaddingContainer>
	);
};
